import React from "react";
import "./Footer.css";
import styles from "./Footer.module.scss";
import { useNavigate } from "react-router-dom";
import { IoHome } from "react-icons/io5";
import { IoHomeOutline } from "react-icons/io5";
import { MdWorkOutline } from "react-icons/md";
import { MdOutlineWork } from "react-icons/md";
import { BsFileEarmarkText } from "react-icons/bs";
import { BsFileEarmarkTextFill } from "react-icons/bs";
import { RiBookmarkFill } from "react-icons/ri";
import { RiBookmarkLine } from "react-icons/ri";

function Footer({ active }) {
  const navigate = useNavigate();

  return (
    <div className={styles.footer}>
      <div
        className={styles.footerBox}
        onClick={() => navigate("/cons-type")}
      >
        {active === "cons" ? (
          <BsFileEarmarkTextFill color="#311944" size={35} />
        ) : (
          <BsFileEarmarkText size={35} />
        )}
        <span>فرم مشاوره</span>
      </div>

      <div
        className={styles.footerBox}
        onClick={() => navigate("/education")}
      >
        {active === "edu" ? (
          <RiBookmarkFill color="#311944" size={35} />
        ) : (
          <RiBookmarkLine size={35} />
        )}
        <span>موقعیت تحصیلی</span>
      </div>

      <div className={styles.footerBox} onClick={() => navigate("/job")}>
        {active === "job" ? (
          <MdOutlineWork color="#311944" size={35} />
        ) : (
          <MdWorkOutline size={35} />
        )}
        <span>موقعیت شغلی</span>
      </div>

      <div className={styles.footerBox} onClick={() => navigate("/home")}>
        {active === "home" ? (
          <IoHome color="#311944" size={35} />
        ) : (
          <IoHomeOutline size={35} />
        )}
        <span>خانه</span>
      </div>
    </div>
  );
}

export default Footer;